export const API_URL = "https://prod.troydepoapi.com/";
export const CHAT_SOCKET_URL = "https://socket.troydepoapi.com";

// Marka logosu sunucudaki public assets'ten çekilir (projeye ağırlık eklemez, tek noktadan
// güncellenir). Her ortam kendi API_URL'inden servis eder. Dosya adı sürümlüdür (asset cache
// 1 ay); logo değişince yeni tarihli dosya + bu sabit güncellenir. Giriş/kayıt/şifremi unuttum
// ekranları ve panel sol üst logosu bunu kullanır.
export const LOGO_URL = `${API_URL}assets/troy-depo-logo-20260915.png`;